import api from '../../utils/services/api';

import {
  detailAccountsActionError,
  detailAccountsActionLoading,
  detailAccountsActionSuccess,
  approvedAccountsActionError,
  approvedAccountsActionLoading,
  approvedAccountsActionSuccess,
  deniedAccountsActionError,
  deniedAccountsActionLoading,
  deniedAccountsActionSuccess,
  blockAccountActionError,
  blockAccountActionLoading,
  blockAccountActionSuccess,
  unlockAccountActionError,
  unlockAccountActionLoading,
  unlockAccountActionSuccess,
  detailAccountsDocumentError,
  detailAccountsDocumentLoading,
  detailAccountsDocumentSuccess,
} from '../ducks/account';
import { hideAlert, showAlert } from '../ducks/sweetAlert';
import { pendingAccountsFetchAction } from './userAccounts';

export const detailAccountsFetchAction = (idConta) => {
  return async (dispatch) => {
    dispatch(detailAccountsActionLoading());
    try {
      const response = await api.get(`/conta-bacen/${idConta}/detalhes`);
      dispatch(detailAccountsActionSuccess(response.data));
    } catch (error) {
      dispatch(detailAccountsActionError(error?.response?.data));
    }
  };
};

export const detailAccountsDocumentFetchAction = (idConta) => {
  return async (dispatch) => {
    dispatch(detailAccountsDocumentLoading());
    try {
      const response = await api.get(`/documentos/${idConta}/pendente`);
      dispatch(detailAccountsDocumentSuccess(response.data));
    } catch (error) {
      dispatch(detailAccountsDocumentError(error?.response?.data));
    }
  };
};

export const approvedAccountsFetchAction = (param, callback) => {
  return async (dispatch) => {
    const closeModals = () => {
      callback();
      dispatch(pendingAccountsFetchAction());
    };
    dispatch(approvedAccountsActionLoading());
    try {
      const response = await api.post(
        `/conta-bacen/new-account/approve`,
        param
      );
      dispatch(approvedAccountsActionSuccess(response.data));

      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Conta aprovado com sucesso!',
          icon: 'success',
          func: closeModals,
        })
      );
    } catch (error) {
      dispatch(approvedAccountsActionError(error?.response?.data));
      dispatch(
        showAlert({
          title: 'Ops...',
          text: error?.response?.data?.mensagem,
          icon: 'error',
          func: closeModals,
        })
      );
    }
  };
};

export const deniedAccountsFetchAction = (param, callback) => {
  return async (dispatch) => {
    const closeModals = () => {
      callback();
      dispatch(pendingAccountsFetchAction());
    };
    dispatch(deniedAccountsActionLoading());
    try {
      const response = await api.post(`/conta-bacen/new-account/deny`, param);
      dispatch(deniedAccountsActionSuccess(response.data));

      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Conta negada com sucesso!',
          icon: 'success',
          func: closeModals,
        })
      );
    } catch (error) {
      dispatch(deniedAccountsActionError(error?.response?.data));
      dispatch(
        showAlert({
          title: 'Ops...',
          text: error?.response?.data?.mensagem,
          icon: 'error',
          func: closeModals,
        })
      );
    }
  };
};

export const blockAccountFetchAction = (idConta, params, callback) => {
  return async (dispatch) => {
    dispatch(blockAccountActionLoading());
    try {
      const response = await api.put(`/conta-bacen/${idConta}/block`, params);
      dispatch(blockAccountActionSuccess(response.data));
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Conta bloqueado com sucesso!',
          icon: 'success',
        })
      );
      callback();
    } catch (error) {
      const errorMessage = error?.response?.data?.mensagem;
      dispatch(
        showAlert({
          title: 'Ops...',
          text: errorMessage,
          icon: 'error',
        })
      );
      dispatch(blockAccountActionError(error?.response?.data));
    }
  };
};

export const unlockAccountFetchAction = (idConta, params, callback) => {
  return async (dispatch) => {
    dispatch(unlockAccountActionLoading());
    try {
      const response = await api.put(`/conta-bacen/${idConta}/unblock`, params);
      dispatch(unlockAccountActionSuccess(response.data));
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Conta desbloqueado com sucesso!',
          icon: 'success',
        })
      );
      callback();
    } catch (error) {
      const errorMessage = error?.response?.data?.mensagem;
      dispatch(
        showAlert({
          title: 'Ops...',
          text: errorMessage,
          icon: 'error',
        })
      );
      dispatch(unlockAccountActionError(error?.response?.data));
    }
  };
};
